import * as React from "react"
import { batch, useSignal } from "@preact/signals-react"

import { ActionButton } from "@components"
import { useToast } from "@hooks"
import { adminProductReviewRawTableData } from "../../../../@signals"
import { useAdminProductReviewForm } from "../../../../@hooks"


export default function SkipButton({ rowData }) {
	const { showToast } = useToast()
	const { handleSendToBack } = useAdminProductReviewForm(rowData)

	const isLoading = useSignal(false)

	const handleClick = () => showToast.confirm(`Are you sure you want to skip the following ${rowData.productName}`, {
		onSubmit: () => {
			isLoading.value = true
			handleSendToBack({ skip: true, qa: true, validated: true }, {
				onSuccess: () => batch(() => {
					isLoading.value = false
					adminProductReviewRawTableData.value = adminProductReviewRawTableData.value.filter(row => row.key !== rowData.key)
				}),
				onFinish: () => isLoading.value = false
			})
		},
	})

	return <ActionButton
		isLoading={isLoading.value}
		label="Skip"
		icon="forward"
		onClick={handleClick}
	/>
}